var controller = new ScrollMagic.Controller();
/*
*
* Toggle Description in PDP
*/
if(document.body.contains( document.querySelector(".toggle-full-desc") )){
    document.querySelector(".toggle-full-desc").addEventListener('click', function() {
          let targetElem = document.getElementById('Full__Desc__Wrap'),
              elemState = targetElem.getAttribute('aria-expanded'),
              reqHeight = document.getElementById('Full__Desc').offsetHeight
          ;
          if( elemState == 'false'){
            targetElem.setAttribute('aria-expanded', 'true');
            targetElem.style.height = reqHeight + 'px';
            window.setTimeout( () => {
              this.innerHTML = 'View less';
            }, 300);
          } else {
            targetElem.setAttribute('aria-expanded', 'false');
            targetElem.style.height = '170px';
            window.setTimeout( () => {
              this.innerHTML = 'View more';
            }, 300);            
          }
          
    });
  
    /*
    *
    * Toggle class
    */
    // var toggleElem = document.querySelector('.toggle-full-desc');
    // toggleElem.onclick = function() {
    //   toggleElem.classList.toggle('open');
    // }
  
  }

// Play Youtube Video in PDP
if(document.body.contains(document.getElementById('Product_Featured_Vdo'))){
  var video = document.getElementById('Product_Featured_Vdo'),
    playBtn = document.getElementById('vdo-player-btn'),
    play
    ;

  var playVideo = playBtn.addEventListener('click', () => {
      playBtn.style.display = "none";
      video.style.display = "block";
      play = video.src += '&autoplay=1';
  });

}

// Initialize Mediabox
MediaBox('.mediabox');
if (document.body.contains(document.querySelector('.template-article .References p'))) {
  document.querySelector(".References__Toggle").addEventListener('click', function (event) {
    slideToggle(document.querySelector(".References__Description"), 400);
    this.classList.toggle('close');
  });
}

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


/**
 * Helpers
 */
var getClosest = function (elem, selector) {

  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
  }

  // Get the closest matching element
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }
  return null;

};

/*
 * Fixing product image list being hard to scroll on iOS13
 */
(function () {
  let touchingCarousel = false,
    touchStartCoords;

  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
  });

  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    let moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };

    if (Math.abs(moveVector.x) > 7)
      e.preventDefault()

  }, {
    passive: false
  });
})();




var slideUp = (target, duration = 500) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

let slideDown = (target, duration = 500) => {
  target.style.removeProperty('display');
  var display = window.getComputedStyle(target).display;

  if (display === 'none')
    display = 'block';

  target.style.display = display;
  var height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}
var slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}
/* 
 *
 * Toggle Description in PDP
 */
if (document.body.contains(document.querySelector(".modal-affiliateType-selector"))) {
  var affliateTypeModal = document.querySelector(".modal-affiliateType-selector"),
    inputAffiliateSelector = affliateTypeModal.querySelectorAll(".input__affiliateselector"),

    continueButton = affliateTypeModal.querySelector('.Button');
  for (let i = 0; i < inputAffiliateSelector.length; i++) {
    inputAffiliateSelector[i].addEventListener("click", function () {
      var dataUrl = inputAffiliateSelector[i].getAttribute("data-url")
      continueButton.setAttribute("href", dataUrl)
    });
  }
}
/* 
 *
 * Toggle Description in PDP
 */
if (document.body.contains(document.querySelector(".toggle-desc"))) {
  let toggles = document.querySelectorAll('.toggle-desc');
  toggles.forEach(function (elem) {
    elem.addEventListener('click', function () {
      elem.parentElement.classList.toggle('open');
      if (elem.innerHTML == "show less") {
        elem.innerHTML = "read more"
      } else {
        elem.innerHTML = "show less";
      }

    })

  });

}

// Play Youtube Video in PDP
if (document.body.contains(document.querySelector('.Product__yt-video'))) {
  var video = document.querySelectorAll('.Product__yt-video');
  var play;
  video.forEach((videoInner)=>{
    playBtn = videoInner.nextElementSibling;
    playBtn.addEventListener('click', (e) => {
      e.target.style.display = "none";
      videoInner.style.display = "block";
      play = videoInner.src += '&autoplay=1';
    });
  })
}

// Video Library
if (document.body.contains(document.querySelector('.js-VideoTrigger'))) {
  var elVideoTrigger = document.getElementsByClassName('js-VideoTrigger');
  for (var i = 0; i < elVideoTrigger.length; i++) {
    elVideoTrigger[i].addEventListener('click', function (event) {

      var elVideoWraper = getClosest(event.target, '.js-VideoWrapper'),
        elVideo = elVideoWraper.querySelector('.js-Video');
      event.target.style.display = "none";
      elVideo.style.display = "block";
      elVideo.src += '&autoplay=1';


    }, false);
  }
}

// Initialize Mediabox
MediaBox('.mediabox');
if (document.body.contains(document.querySelector('.template-article .References p'))) {
  document.querySelector(".References__Toggle").addEventListener('click', function (event) {
    slideToggle(document.querySelector(".References__Description"), 400);
    this.classList.toggle('close');
  });
}

// Marquee
function configMarquee() {
  if (document.body.contains(document.querySelector('.Marquees__Wrapper'))) {
    var elements = document.getElementsByClassName('Marquees__Wrapper');
    for (var i = 0; i < elements.length; i++) {
      var elmWidth = elements[i].offsetWidth;
      elements[i].style.animationDuration = elmWidth / 60 + 's';
      elements[i].style.animationDelay = ((elmWidth / -100) / (parseInt(elements[i].getAttribute('data-maquees-size')))) / 2 + 's';
    }
  }
}
configMarquee();

// Product Description Block Toggles 
function productblockToggle() {
  if (document.body.contains(document.querySelector('.ProductMeta__Desc-Full'))) {
    var productSections = document.querySelectorAll('.ProductMeta__Desc-Full .BlockText__Content'),
      winWidh = window.innerWidth;
    productSections.forEach(function (productSection) {
      let innerSectionHeight = productSection.querySelector('.BlockText__ContentInner').offsetHeight;
      if (winWidh > 767) {
        if (innerSectionHeight > 250) {
          productSection.classList.add('BlockText__Content--toggleWrap');
        } else {
          productSection.classList.remove('BlockText__Content--toggleWrap');
        }

      } else if (winWidh < 767 && innerSectionHeight > 110) {
        productSection.classList.add('BlockText__Content--toggleWrap');
      }
    });
  }
}
productblockToggle();

function handleWinResize() {
  // Resize code here
  configMarquee();
  productblockToggle();
}

var elem = document.querySelectorAll('.FAQ_Carousel');
if (elem.length) {
  elem.forEach(function (el) {
    var flkty = new Flickity(el, {
      "prevNextButtons": true,
      "pageDots": true,
      "draggable": false
    });
  })
}

var resizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(handleWinResize, 250);
});

function insertAfter(referenceNode, newNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

if(document.body.classList.contains('template-collection')){
  const allCollectionProduct = document.querySelectorAll('.ProductItem');
  Array.from(allCollectionProduct).forEach((product)=>{
    const quantityWrapper = product.querySelector('.ProductForm__QuantitySelector');
    const minusQuantity = quantityWrapper.querySelector('[data-action-col="decrease-quantity"]');
    const inputQuantity = quantityWrapper.querySelector('[name="quantity"]');
    const plusQuantity = quantityWrapper.querySelector('[data-action-col="increase-quantity"]');
    minusQuantity.disabled = true;

    minusQuantity.addEventListener('click',(e)=>{
      if(inputQuantity.value <= 1){
        minusQuantity.disabled = true;
        return;
      }
      minusQuantity.disabled = false;
      console.log(inputQuantity.value);
      inputQuantity.value = parseInt(inputQuantity.value) - 1;
    });

    plusQuantity.addEventListener('click',(e)=>{
      console.log(inputQuantity.value);
      inputQuantity.value = parseInt(inputQuantity.value) + 1;
    })
  })
}

  document.addEventListener('click', function (e) {
    if (e.target.getAttribute('data-action') == 'handleSubscription') {
      var subscriptions = JSON.parse(e.target.getAttribute('data-subscriptions'));
      var data = {
        "form_type": "product",
        "utf8": "✓",
        "properties": {
          "_purchase_type": "autodeliver",
          "_product_limit": subscriptions._product_limit,
          "_subscription_only": subscriptions.is_subscription_only,
          "_downgrade_variant_id": e.target.getAttribute('data-downgrade-variant-id'),
          "_downgrade_variant_price": e.target.getAttribute('data-downgrade-variant-price'),
          "_downgrade_variant_url": e.target.getAttribute('data-downgrade-variant-url'),
          "_subscription_discount_percentage": String(parseInt(subscriptions.discount_percentage)),
          "subscription_id": subscriptions.subscription_id,
          "shipping_interval_unit_type": subscriptions.shipping_interval_unit_type,
          "shipping_interval_frequency": subscriptions.shipping_interval_frequency.split(",")[0],
          "_shippping_interval_frequencies": subscriptions.shipping_interval_frequency
        },
        "id": e.target.getAttribute('data-subscription-variant-id'),
        "purchase_type": "autodeliver",
        "quantity": e.target.getAttribute('data-quantity')
      };
      e.target.disabled = true;
      e.target.classList.add('disabled');

      if (document.querySelector('#sidebar-cart .Cart__ItemList') != null && document.querySelector('#sidebar-cart .Cart__ItemList').hasAttribute('data-product-limit')) {
        var productLimits = JSON.parse(document.querySelector('#sidebar-cart .Cart__ItemList').getAttribute('data-product-limit'));
      } else {
        var productLimit = parseInt(subscriptions._product_limit);
      }
      if (productLimits == undefined || productLimits["id" + data.id] == undefined) {
        if (productLimit == undefined || parseInt(data.quantity) <= productLimit) {
          e.target.textContent = "Upgrading...";
          addItemToCart(e, data, e.target.getAttribute('data-key'));
        } else {
          e.target.textContent = "Subscription limit reached";
        }
      } else if (parseInt(data.quantity) <= parseInt(productLimits["id" + data.id])) {
        e.target.textContent = "Upgrading...";
        addItemToCart(e, data, e.target.getAttribute('data-key'));
      } else {
        e.target.textContent = "Subscription limit reached";
      }
    }
  }, false);

  function addItemToCart(e, data, removeKey) {
    fetch("/cart/add.js", {
      body: JSON.stringify(data),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest" // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (response) {
      if (response.ok) {
        function remover(name, callback) {
          document.querySelector('.CartItem__Remove[data-line-id="' + removeKey + '"]').click();
          callback();
        }

        function callingS() {
          setTimeout(() => {
            if (window.location.href.indexOf("cart") > -1) {
              // location.reload();
            }
          }, 10000);
        }

        remover('Product Removed', callingS);

      } else {
        response.json().then(function (content) {});
      }

      // response.json().then(function (content) {});
    });
  }

  function updateCartItem(e, data) {
    var textContent = e.target.options[0].textContent;
    e.target.disabled = true;
    e.target.classList.add('disabled');
    e.target.options[0].textContent = "Updating...";
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    fetch("/cart/change.js", {
      body: JSON.stringify(data),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest" // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (response) {
      if (response.ok) {
        e.target.classList.remove('disabled');
        e.target.disabled = false;
        e.target.options[0].textContent = textContent;

        document.dispatchEvent(new CustomEvent("theme:loading:end"));
      } else {
        response.json().then(function (content) {});
      }
    });
  }


// Time Line
let timelineWrap = document.querySelector('.Weekly__Timeline');
if (document.body.contains(document.querySelector('.Weekly__Timeline'))) {
  let timelineItems = timelineWrap.querySelectorAll('.Weekly__Timeline--item');
  timelineItems.forEach(function (elem) {
    let scene = new ScrollMagic.Scene({
        triggerElement: elem,
        triggerHook: 0.55
      })
      .setClassToggle(elem, 'in-view')
      .addTo(controller);
  });
}


// Check if screen nav is on top or not for quiz modal
if (document.body.contains(document.querySelector('#modal-quiz'))) {
  modalPosition = document.querySelector('#modal-quiz');
  var headerItem = document.querySelector('#section-announcement');
  if (!document.body.contains(headerItem)) {
    modalPosition.style.top = '60px';
  } else if (document.body.contains(modalPosition)) {
    document.addEventListener('scroll', function (e) {
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      lastKnownScrollPosition = window.scrollY;
      if (lastKnownScrollPosition < 60) {
        modalPosition.style.top = 110 - lastKnownScrollPosition + 'px';
      } else {
        modalPosition.style.top = '50px';
      }
    });
  }
}

// Info FLickity 
if (document.body.contains(document.querySelector('.Layout--card-info'))) {
  var flkty = new Flickity('.Layout--card-info', {
    "groupCells": false,
    "prevNextButtons": true,
    "pageDots": true,
    "imagesLoaded": false
  });

  var carouselStatus = document.querySelector('.Layout--card-info-status');

  function updateStatus() {
    var slideNumber = flkty.selectedIndex + 1;
    carouselStatus.innerHTML = '<span class="number">' + slideNumber + '</span> of <span class="number">' + flkty.slides.length + '</span>';
  }
  updateStatus();
  flkty.on('select', updateStatus);
}


// Page Brain and cell health CTA 
let buttonCart = document.querySelectorAll('.Button_cart_direct');
let productCart = document.querySelector('.Product_main_CTA');
buttonCart.forEach(function (item) {
  item.addEventListener('click', function (e) {
    e.preventDefault();
    productCart.click();
  })
})

let cartHeader = document.querySelectorAll('.cartLink');
cartHeader.forEach((item)=>{
  item.addEventListener('click',(e)=>{
    e.preventDefault();
  })
})

window.addEventListener("pageshow", function(evt){
    if(evt.persisted){
        setTimeout(function(){
            window.location.reload();
         },10);
    }
}, false);


// Remove sextra restricted section
if(document.body.contains(document.querySelector('#section-restricted'))){
  let restrictedsection = document.querySelectorAll('#section-restricted');
  restrictedsection.forEach((item,index)=>{
    if(index > 0){
      item.style.display = 'none';
    }
  })
}

// Let Klaviyo Load first 
window.onload = function () {

  let imageSlider = document.querySelector('.product-large_container');
  
  if(document.body.contains(imageSlider)){
    let imgWrapperMain = imageSlider.querySelector('.product-img .carousel-main-tab');
    let imgNav = imageSlider.querySelector('.carousel-nav-tab');
    if (imgWrapperMain) {
      let flickityMain = new Flickity(imgWrapperMain,{
        adaptiveHeight: true, 
        prevNextButtons: false, 
        pageDots: false, 
        imagesLoaded: true,
      });
    
      if (imgNav) {
        let flickityNav = new Flickity(imgNav,{
          asNavFor: imgWrapperMain,
          wrapAround: false,
          prevNextButtons: false, 
          pageDots: false, 
          imagesLoaded: true,
          cellAlign: 'center',
          on: {
            ready: function() {
              console.log('Flickity ready');
            }
          }
        });
    
        totalImg = imgNav.querySelectorAll('.img-wrapper-nav');
        if(totalImg.length <= 1){
          imgNav.style.display = "none";
        }
      } 
    }
  
  }

  let pointerFrom = 0;
  let elementFrom = 0;

  const scrollable = document.querySelector('.tabs');

  const onDrag = (event) => {
    // Ensure we only do this for pointers that don't have native
    // drag-scrolling behavior and when the pointer is down.
    if (event.pointerType == 'mouse') {
      scrollable.scrollLeft = elementFrom - event.clientX + pointerFrom;
    }
  };

  if(document.body.contains(scrollable)) {
    scrollable.addEventListener('pointerdown', (event) => {
      // Ensure we only do this for pointers that don't have native
      // drag-scrolling behavior.
      if (event.pointerType == 'mouse') {
        pointerDown = true;
        // Set the position where the mouse is starting to drag from.
        pointerFrom = event.clientX;
        // Set the position of the element is scrolled from.
        elementFrom = scrollable.scrollLeft;

        // React on pointer move.
        document.addEventListener('pointermove', onDrag);
      }
    });

    // Stop reacting on pointer move when pointer is no longer clicked.
    document.addEventListener('pointerup', (event) => {
      // Ensure we only do this for pointers that don't have native
      // drag-scrolling behavior.
      if (event.pointerType == 'mouse') {
        document.removeEventListener('pointermove', onDrag);
      }
    });

    // Custom tabs 
    const tabs = document.querySelectorAll(".tab");
    const tabContent = document.querySelectorAll(".tab-content");

    tabs.forEach((tab, i) => {
      tab.addEventListener("click", function () {
        tabs.forEach(tab => tab.classList.remove("active"));
        this.classList.add("active");
        tabContent.forEach(content => content.classList.add("hidden"));
        tabContent[i].classList.remove("hidden");
      });
    });

    // Accordion 
    const items = document.querySelectorAll('.accordion button');

    function toggleAccordion() {
      const itemToggle = this.getAttribute('aria-expanded');

      for (i = 0; i < items.length; i++) {
        items[i].setAttribute('aria-expanded', 'false');
      }

      if (itemToggle == 'false') {
        this.setAttribute('aria-expanded', 'true');
      }
    }

    items.forEach((item) => item.addEventListener('click', toggleAccordion));
  }

  //Klaviyo form fix
  var specifiedElement = document.querySelector('.signup-form');
  var lipoForm = document.querySelector(".ValidationMessage__Container-sc-1agouhi-0");
  if (document.body.contains(specifiedElement)) {
    document.addEventListener('click', function (event) {
      var isClickInsideKlaviyoLipo = specifiedElement.contains(event.target);
      if (!isClickInsideKlaviyoLipo) {
        if (lipoForm.hasChildNodes()) {
          while (lipoForm.hasChildNodes()) {
            lipoForm.removeChild(lipoForm.firstChild);
          }
        }
        return;
      }
    });
  }
}

document.addEventListener('click', function (event) {
  var selectors = ['[data-action="toggle-product-card"]'];
  try {
    let target = event.target;
    if (!target) {
      return;
    }

    // if target matches selectors we have what we looking for.
    if (!target.matches(selectors)) {
      // if not keep looking
      target = target.closest(selectors);
    }

    if (!target) {
      return;
    }

    if (target.matches(selectors)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var $productItem = target.closest(".ProductItem");

      if ($productItem.getAttribute('aria-expanded') === 'true') {
        $productItem.setAttribute('aria-expanded', false);
        return;
      }

      $productItem.setAttribute('aria-expanded', true);
    }
  } catch (e) {
    console.error(e.message);
  }
});


var lastScrollY = window.scrollY;

window.addEventListener("scroll", function() {
  var scrollY = window.scrollY;

  if (scrollY > lastScrollY + 10) {
    document.body.classList.remove("scrolledUp");
    document.body.classList.add("scrolledDown");
    document.documentElement.style.setProperty('--scrolled-up', 0);
    lastScrollY = scrollY;
  } else if (scrollY < lastScrollY - 10) {
    document.body.classList.add("scrolledUp");
    document.body.classList.remove("scrolledDown");
    document.documentElement.style.setProperty('--scrolled-up', 1);
    lastScrollY = scrollY;
  }
});

// if(document.body.contains(document.querySelector('.Collapsible'))){
//   let collapsible = document.querySelectorAll('.Collapsible');
//   collapsible.forEach((item,index)=> {
//     item.addEventListener('click', (e) =>{
//       let btn = item.querySelectorAll('.Collapsible__Button');
//       btn.forEach((btnInner,ind)=>{
//         const collapsibleInner = btnInner.nextElementSibling;
//         console.log(collapsibleInner);
//         if(btnInner.getAttribute('aria-expanded') == false || btnInner.getAttribute('aria-expanded') == 'false'){
//           btnInner.setAttribute('aria-expanded','true');
//           collapsibleInner.style.overflow = 'visible';
//           collapsibleInner.style.height = 'auto';
//         } else {
//           btnInner.setAttribute('aria-expanded','false');
//           collapsibleInner.style.overflow = 'hidden';
//           collapsibleInner.style.height = 0;
//         }
//       })
//     });
//   })
// }

// TOS modal

document.addEventListener( "click", async function (event) {
  const el = event.target;

  try {
    if (
      el.tagName === 'BUTTON' && el.classList.contains("Cart__TOSModalButton") ||
      (el.tagName === 'SPAN' && el?.parentElement?.classList.contains("Cart__TOSModalButton"))
    ) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const tosModal = document.querySelector('.tos-modal-wrapper');

      tosModal.classList.add('is-open');

      return false;
    }

    if (el.tagName === 'BUTTON' && el.classList.contains("TOS__ModalCancelButton")) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const tosModal = document.querySelector('.tos-modal-wrapper');

      tosModal.classList.remove('is-open');

      return false;
    }

    if (el.tagName === 'BUTTON' && el.classList.contains("TOS__ModalAcceptButton")) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const cartForm = document.querySelector('form.Cart');
      const tosModal = document.querySelector('.tos-modal-wrapper');
      const tosModalCheckbox = tosModal.querySelector('.tos-modal-checkbox');
      const customerId = tosModal.dataset.customerId;

      if (!tosModalCheckbox.checked) {
        return false;
      }

      el.classList.add('disabled');

      const acceptTOSRes = await fetch('https://hcpapp.bodybio.com/api/shopify/customer/accept-tos', {
        method: 'POST',
        body: JSON.stringify({ customerId }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const acceptTOSData = await acceptTOSRes.json();

      if (acceptTOSData?.id) {
        window.location = '/checkout';
      }

      return false;
    }

    if (el.tagName === 'INPUT' && el.classList.contains("tos-modal-checkbox")) {
      const tosModalAcceptButton = document.querySelector('.TOS__ModalAcceptButton');

      if (el.checked) {
        tosModalAcceptButton.classList.remove('disabled');
      } else {
        tosModalAcceptButton.classList.add('disabled');
      }
    }

    if (el.tagName === 'BUTTON' && el.dataset.action === 'notify-drop-ship-order') {
      event.preventDefault(); // Prevent form to be submitted

      // First, we switch the status of the button
      el.setAttribute('disabled', 'disabled');

      var items = [
        {
          quantity: el.getAttribute('data-quantity'),
          id: el.getAttribute('data-variant-id')
        }
      ];

      var data = {
        "items": items
      }

      fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      }).then(function (response) {
        if (response.ok) {
          window.location = '/checkout';
        } else {
          console.log('error response', response);
        }
      });
    }
  } catch (e) {
    console.log('has accepted TOS check e', e);
  }
});
